import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, extractError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Trash2 } from "lucide-react";

export default function AdminUsers() {
  const { user: me } = useAuth();
  const [items, setItems] = useState([]);
  const load = () => api.get("/users").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const remove = async (id) => {
    if (!window.confirm("Supprimer cet utilisateur ?")) return;
    try {
      await api.delete(`/users/${id}`);
      toast.success("Utilisateur supprimé");
      load();
    } catch (e) { toast.error(extractError(e)); }
  };
  return (
    <div>
      <h1 className="font-display text-3xl font-black text-[#0a1e3f]">Utilisateurs</h1>
      <p className="text-sm text-gray-500 mt-1">Comptes clients, agences et administrateurs.</p>

      {/* Mobile: card layout */}
      <div className="mt-6 space-y-3 md:hidden">
        {items.length === 0 ? <div className="bg-white rounded-2xl p-8 text-center text-gray-400 border border-dashed">Aucun utilisateur.</div> :
          items.map((u) => (
            <div key={u.id} className="bg-white rounded-2xl p-4 border border-gray-100 mbk-card-shadow">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-[#0a1e3f] truncate">{u.full_name}</div>
                  <div className="text-xs text-gray-500 truncate">{u.email}</div>
                  <div className="mt-2 flex items-center gap-2 flex-wrap">
                    <span className="text-xs bg-[#0a1e3f]/5 text-[#0a1e3f] font-bold px-2 py-0.5 rounded-full">{u.role}</span>
                    <span className="text-xs text-gray-400">{new Date(u.created_at).toLocaleDateString("fr-FR")}</span>
                  </div>
                </div>
                {u.id !== me?.id ? (
                  <button
                    onClick={() => remove(u.id)}
                    data-testid={`delete-user-${u.id}`}
                    className="h-10 w-10 rounded-full bg-red-50 text-red-600 flex items-center justify-center shrink-0 border border-red-100 active:bg-red-100"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                ) : (
                  <span className="text-xs text-gray-400 shrink-0">(vous)</span>
                )}
              </div>
            </div>
          ))}
      </div>

      {/* Desktop: table layout */}
      <div className="hidden md:block mt-6 bg-white rounded-2xl border border-gray-100 mbk-card-shadow overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-gray-50 text-xs uppercase tracking-widest text-gray-500">
            <tr>
              <th className="p-4 text-left">Nom</th>
              <th className="p-4 text-left">Email</th>
              <th className="p-4 text-left">Rôle</th>
              <th className="p-4 text-left">Créé le</th>
              <th className="p-4 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((u) => (
              <tr key={u.id} className="border-t border-gray-100 hover:bg-gray-50/50">
                <td className="p-4 font-semibold text-[#0a1e3f]">{u.full_name}</td>
                <td className="p-4">{u.email}</td>
                <td className="p-4"><span className="text-xs bg-[#0a1e3f]/5 text-[#0a1e3f] font-bold px-2 py-1 rounded-full">{u.role}</span></td>
                <td className="p-4 text-xs text-gray-500">{new Date(u.created_at).toLocaleDateString("fr-FR")}</td>
                <td className="p-4 text-right">
                  {u.id !== me?.id ? (
                    <button
                      onClick={() => remove(u.id)}
                      data-testid={`delete-user-${u.id}`}
                      className="h-9 w-9 rounded-full bg-red-50 text-red-600 hover:bg-red-100 border border-red-100 inline-flex items-center justify-center"
                    >
                      <Trash2 className="h-4 w-4" />
                    </button>
                  ) : (
                    <span className="text-xs text-gray-400">(vous)</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
